import script from "./AddAction.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAction.vue?vue&type=script&setup=true&lang=js"

import "./AddAction.vue?vue&type=style&index=0&id=7b7e8ae7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b7e8ae7"]])

export default __exports__